// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Spinner_small__AqIrE {
  display: inline-block;
  position: relative;
  width: 18px;
  height: 18px;
}

.Spinner_big__iWzI- {
  display: inline-block;
  position: relative;
  width: 80px;
  height: 80px;
}

.Spinner_small__AqIrE div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 14px;
  height: 14px;
  margin: 2px;
  border: 2px solid;
  border-radius: 50%;
  animation: Spinner_spinner__MrWKw 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.Spinner_big__iWzI- div {
  box-sizing: border-box;
  display: block;
  position: absolute;
  width: 64px;
  height: 64px;
  margin: 8px;
  border: 8px solid;
  border-radius: 50%;
  animation: Spinner_spinner__MrWKw 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;
}

.Spinner_white__34y-- div {
  border-color: #fff transparent transparent transparent;
}

.Spinner_black__io6b9 div {
  border-color: #000 transparent transparent transparent;
}

.Spinner_blue__vAhm6 div {
  border-color: #054AB0 transparent transparent transparent;
}

.Spinner_spinner__MrWKw div:nth-child(1) {
  animation-delay: -0.45s;
}

.Spinner_spinner__MrWKw div:nth-child(2) {
  animation-delay: -0.3s;
}

.Spinner_spinner__MrWKw div:nth-child(3) {
  animation-delay: -0.15s;
}

@keyframes Spinner_spinner__MrWKw {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/common/Spinner/Spinner.module.scss"],"names":[],"mappings":"AAAA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4EAAA;AACF;;AAEA;EACE,sBAAA;EACA,cAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,iBAAA;EACA,kBAAA;EACA,4EAAA;AACF;;AAEA;EACE,sDAAA;AACF;;AAEA;EACE,sDAAA;AACF;;AAEA;EACE,yDAAA;AACF;;AAEA;EACE,uBAAA;AACF;;AACA;EACE,sBAAA;AAEF;;AAAA;EACE,uBAAA;AAGF;;AADA;EACE;IACE,uBAAA;EAIF;EAFA;IACE,yBAAA;EAIF;AACF","sourcesContent":[".small {\n  display: inline-block;\n  position: relative;\n  width: 18px;\n  height: 18px;\n}\n\n.big {\n  display: inline-block;\n  position: relative;\n  width: 80px;\n  height: 80px;\n}\n\n.small div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 14px;\n  height: 14px;\n  margin: 2px;\n  border: 2px solid;\n  border-radius: 50%;\n  animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n}\n\n.big div {\n  box-sizing: border-box;\n  display: block;\n  position: absolute;\n  width: 64px;\n  height: 64px;\n  margin: 8px;\n  border: 8px solid;\n  border-radius: 50%;\n  animation: spinner 1.2s cubic-bezier(0.5, 0, 0.5, 1) infinite;\n}\n\n.white div {\n  border-color: #fff transparent transparent transparent;\n}\n\n.black div {\n  border-color: #000 transparent transparent transparent;\n}\n\n.blue div {\n  border-color: #054AB0 transparent transparent transparent;\n}\n\n.spinner div:nth-child(1) {\n  animation-delay: -0.45s;\n}\n.spinner div:nth-child(2) {\n  animation-delay: -0.3s;\n}\n.spinner div:nth-child(3) {\n  animation-delay: -0.15s;\n}\n@keyframes spinner {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"small": `Spinner_small__AqIrE`,
	"big": `Spinner_big__iWzI-`,
	"spinner": `Spinner_spinner__MrWKw`,
	"white": `Spinner_white__34y--`,
	"black": `Spinner_black__io6b9`,
	"blue": `Spinner_blue__vAhm6`
};
export default ___CSS_LOADER_EXPORT___;
